export const baseHeight = 36;
export const borderRadius = 2;
